const animation = { duration: 3000, easing: ( t ) => t }

const autoplay = (s) => {
    requestAnimationFrame( () => {
        s.moveToIdx( s.track.details.abs + 1, true, animation );
    } );
}

export const sliderOptions = {
    loop: true,
    selector: 'img',
    slides: {
        origin: 'center',
        perView: 'auto',
        spacing: 30
    },
    created : autoplay,
    updated: autoplay,
    animationEnded: autoplay,
};
